import axios from 'axios';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const TOKEN_KEY = 'essbee_admin_token';

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const auth = {
  async login(email, password) {
    const { data } = await api.post('/admin/login', { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },
  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
  async me() {
    const { data } = await api.get('/admin/me');
    return data;
  },
};

export const enquiries = {
  async list({ status = '', search = '', limit = 200, skip = 0 } = {}) {
    const params = {};
    if (status) params.status_filter = status;
    if (search) params.search = search;
    params.limit = limit;
    params.skip = skip;
    const { data } = await api.get('/admin/enquiries', { params });
    return data;
  },
  async updateStatus(id, status) {
    const { data } = await api.patch(`/admin/enquiries/${id}`, { status });
    return data;
  },
  async remove(id) {
    const { data } = await api.delete(`/admin/enquiries/${id}`);
    return data;
  },
  async stats() {
    const { data } = await api.get('/admin/stats');
    return data;
  },
  async submit(payload) {
    const { data } = await api.post('/enquiries', payload);
    return data;
  },
};
